import { observable } from "../../core/services/observable.js";

const [subscribeDOMRendered, subscribeDOMDestroyed] = (() => {

    const queueRender = new Set(),
        queueDestroy = new Set(),
        queueDomRendered = new Set();

    const canRemove = (removedNodeList, dom) => removedNodeList.has(dom) && queueDomRendered.has(dom);
    const toCollection = (sources) => new Set(sources);
    const observer = new MutationObserver(function (mutations) {

        for (let i = 0; i < mutations.length; i++) {
            const target = mutations[i];
            const { type } = target;
            const addedNodes = toCollection(target.addedNodes),
                removedNodes = toCollection(target.removedNodes);
            if (type !== 'childList') continue;
            if (addedNodes.size > 0) {
                queueRender.forEach(registeredItem => {
                    const { cb, dom, args } = registeredItem;
                    if (addedNodes.has(dom)) {
                        cb.call(null, args);
                        queueRender.delete(registeredItem);
                        queueDomRendered.add(dom);
                    }
                })
            }

            if (removedNodes.size > 0) {
                queueDestroy.forEach(registeredItem => {
                    const { cb, dom, args } = registeredItem;
                    if (canRemove(removedNodes, dom)) {
                        queueDomRendered.delete(dom);
                        queueDestroy.delete(registeredItem);
                        cb.call(null, args);
                    }
                })
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const subscribeRendered = (targetDOM, callback, args) => {
        const newItem = {
            dom: targetDOM,
            cb: callback,
            args
        }
        queueRender.add(newItem);
        return () => {
            queueRender.delete(newItem);
        }

    }

    const subscribeDestroyed = (targetDOM, callback, args) => {
        const newItem = {
            dom: targetDOM,
            cb: callback,
            args
        }
        queueDestroy.add(newItem);
        return () => {
            queueDestroy.delete(newItem);
        }
    }

    return [subscribeRendered, subscribeDestroyed];
})();

const [_subscribeEvent, _emitEvent] = observable();

class Observer {

    static SubscribeResize(targetElement, callback = function () { }) {
        const resizeObserver = new ResizeObserver((entries) => {
            callback.call(null, entries);
        });

        resizeObserver.observe(targetElement)

        return () => {
            resizeObserver.disconnect();
        }
    }

    static SubscribeDOMRendered = subscribeDOMRendered;

    static SubscribeDOMDestroyed = subscribeDOMDestroyed;

    static SubscribeEvent = _subscribeEvent;
}

class Emitter {
    static EmitEvent = _emitEvent;
}

export default Observer;
export { Emitter };